import _ from 'lodash';

export const rts = {
  handleGo_next: 'handleGo_next',
  handleGo_back: 'handleGo_back',
  handleGo_backTo: 'handleGo_backTo',
  handleGo_replace: 'handleGo_replace',
  handleSet_value: 'handleSet_value',
  handleReset_value: 'handleReset_value',
  handleShow_commit: 'handleShow_commit',
  handleClose_diffs: 'handleClose_diffs',
  handleAmmend_propItem: 'handleAmmend_propItem',
  handleAmmend_viewItem: 'handleAmmend_viewItem',
  handleAmmend_updateViewItemsInViews: 'handleAmmend_updateViewItemsInViews'
};

export const squaresInitialState = (baseline, isGlobal, pageView, view, viewKey, menuAuthGroups, _basePageView) => ({
  baseline: _.cloneDeep(baseline), // never mutate this
  apsGlobal: _.cloneDeep(baseline.aps_global),
  apsViewItems: _.cloneDeep(baseline.aps_viewItems),
  apsViews: _.cloneDeep(baseline.aps_views),
  isGlobal,
  view,
  viewKey,
  pageView,
  direction: 'left',
  allGroups: [_.cloneDeep(menuAuthGroups)]
});

const _appPathTypes = {
  global: 'global',
  viewItems: 'viewItems',
  views: 'views',
}

export const squaresReducer = (state, action) => {

  const { type, value, cp, cpf } = action;
  const { isGlobal, pageView } = state

  const _keyIgnores = isGlobal ? [] : ['pageOptions', 'view']

  switch (type) {

    case rts.handleGo_next:
      let currentViProps;
      if (action.item.props && action.parentGroupKey === 'views') {
        currentViProps = _.keys(action.item.props)
      }
      const agi = {
        ...action.item,
        parentGroupKey: action.parentGroupKey || null,
        isParentItem: action.item.childItems ? true : false,
        isChildItem: state.allGroups[_.size(state.allGroups) - 1]?.isParentItem
      }
      const _allGroups = [
        ...state.allGroups,
        { ...agi },
      ]

      const keyPath = _allGroups
        .map(({ key }) => key)
        .filter(Boolean)
        .filter(key => !_keyIgnores.includes(key))
        .slice(isGlobal ? 1 : 0)
        .join('.')

      return {
        ...state,
        allGroups: _allGroups,
        direction: 'right',
        currentViProps,
        keyPath,
      }

    case rts.handleGo_replace:
      return { ...state }

    case rts.handleGo_back:
      if (state.allGroups.length <= 1) { return state }
      const all_groups = state.allGroups.slice(0, -1)
      const key_path = all_groups
        .map(({ key }) => key)
        .filter(Boolean)
        .filter(key => !_keyIgnores.includes(key))
        .slice(isGlobal ? 1 : 0)
        .join('.')
      return { ...state, allGroups: all_groups, direction: 'left', keyPath: key_path }

    case rts.handleGo_backTo:
      const { index } = action;
      if (index < 0 || index >= state.allGroups.length) return state
      if (state.allGroups.length <= 1) return state // ⛔ root protected 
      const all_groupz = state.allGroups.slice(0, index + 1)
      const key_pathh = all_groupz
        .map(({ key }) => key)
        .filter(Boolean)
        .filter(key => !_keyIgnores.includes(key))
        .slice(isGlobal ? 1 : 0)
        .join('.')

      return {
        ...state,
        allGroups: all_groupz,
        keyPath: key_pathh
      }

    case rts.handleAmmend_viewItem:
      return updateViewItem(state, action.viewItemKey, action.viewItem)

    case rts.handleAmmend_updateViewItemsInViews:
      console.log('action', action)
      if (action.isGlobal) {
        return updateViewItemsInGlobal(state, action.items, action.positionsOnly)
      } else {
        return updateViewItemsInViews(state, action.items, action.positionsOnly)
      }

    case rts.handleAmmend_propItem:
      return updatePropItem(state, action.propItemKey, action.propItem)

    case rts.handleSet_value: {
      // value, cp, cpf
      const agz = _.cloneDeep(state.allGroups)

      let _cp = isGlobal ? state.keyPath : `${state.pageView}.${state.keyPath}`
      const _cps = _cp ? _cp.split('.') : []
      // const _isViewItem = _cp ? _cp.split('.')[0] === 'views' : false // determine which source 

      const _isViewItem = isGlobal && _cps[0] === 'views'
      const _isView = !isGlobal && _.includes(_cps, 'view')

      const _appPathType = isGlobal ? _isViewItem ? _appPathTypes.viewItems : _appPathTypes.global : _appPathTypes.views

      const nextState = _.cloneDeep(state);

      switch (_appPathType) {
        case _appPathTypes.global:
          _.set(nextState.apsGlobal, _cp, value);
          break;
        case _appPathTypes.viewItems:
          _cp = removeFromStart(_cp, 1)
          _.set(nextState.apsViewItems, _cp, value);
          // let _cpvi = action.cp ? action.cp : _cp
          // _cpvi = removeFromStart(_cpvi, 1)
          // _.set(nextState.apsViewItems, _cpvi, value);
          // const xxx = nextState.apsViewItems[state.view]
          // agz[agz.length - 1] = xxx
          break;
        case _appPathTypes.views:
          const _cpv = action.cp || _cp
          if (isGlobal) {
            _.set(nextState.apsViews, _cpv, value);
          } else {
            const zzz = action.itemKey ? `${_cp}.${action.itemKey}` : _cpv
            _.set(nextState.apsViews, zzz, value);
          }
          // _.set(nextState.apsViews, _cpv, value);
          // const ppp = removeFromEnd(_cpv, 2)
          // const aaa = _.get(nextState.apsViews, ppp, {});
          // agz[agz.length - 2] = aaa
          break;
      }

      const { _diffs, diffCount } = getDiffs(nextState)
      console.groupEnd()
      return { ...nextState, dataHasChanged: true, _diffs, diffCount, allGroups: agz };
    }

    case rts.handleReset_value: {
      const baseline = _.cloneDeep(state.baseline);
      return {
        baseline,
        apsGlobal: _.cloneDeep(baseline.aps_global),
        apsViewItems: _.cloneDeep(baseline.aps_viewItems),
        apsViews: _.cloneDeep(baseline.aps_views),
        diffCount: 0,
        showCommit: false,
        diffs: null,
        dataHasChanged: false
      };
    }

    case rts.handleShow_commit: {
      const { _diffs, diffCount } = getDiffs(state)
      return {
        ...state,
        diffs: _diffs,
        diffCount: diffCount,
        showCommit: true,
      }
    }

    case rts.handleClose_diffs:
      return { ...state, showCommit: false }

    default:
      return state;
  }
};

// Handlers for use with dispatch
export const squaresHandlers = (dispatch) => ({
  handleGo_next: (item, parentGroupKey, origin) => dispatch({ type: rts.handleGo_next, item, parentGroupKey, origin }),
  handleGo_back: () => dispatch({ type: rts.handleGo_back }),
  handleGo_replace: (replacementGroup, currentGroup) => dispatch({ type: rts.handleGo_replace, replacementGroup, currentGroup }),
  handleGo_backTo: (index) => dispatch({ type: rts.handleGo_backTo, index }),
  handleSet_value: (value, cp, cpf, itemKey) => dispatch({ type: rts.handleSet_value, value, cp, cpf, itemKey }),
  handleReset_value: () => dispatch({ type: rts.handleReset_value }),
  handleShow_commit: () => dispatch({ type: rts.handleShow_commit }),
  handleClose_diffs: () => dispatch({ type: rts.handleClose_diffs }),
  handleAmmend_propItem: (propItemKey, propItem) => dispatch({ type: rts.handleAmmend_propItem, propItemKey, propItem }),
  handleAmmend_viewItem: (viewItemKey, viewItem) => dispatch({ type: rts.handleAmmend_viewItem, viewItemKey, viewItem }),
  handleAmmend_updateViewItemsInViews: (isGlobal, items, positionsOnly) => dispatch({ type: rts.handleAmmend_updateViewItemsInViews, isGlobal, items, positionsOnly }),
});

// const getDiffXXX = (obj, base) =>
//   _.transform(obj, (result, value, key) => {
//     if (!_.isEqual(value, base[key])) {
//       result[key] =
//         _.isObject(value) && _.isObject(base[key])
//           ? getDiff(value, base[key])
//           : value;
//     }
//   }, {});

const getDiff = (obj, base) =>
  _.transform(obj, (result, value, key) => {
    if (!_.isEqual(value, base[key])) {
      result[key] =
        _.isPlainObject(value) && _.isPlainObject(base[key])
          ? getDiff(value, base[key])
          : value;
    }
  }, {});

const diffToFirestoreUpdate = (diff, basePath = '') => {
  return _.transform(diff, (result, value, key) => {
    const path = basePath ? `${basePath}.${key}` : key;

    // recurse ONLY for plain objects
    if (_.isPlainObject(value)) {
      Object.assign(result, diffToFirestoreUpdate(value, path));
    } else {
      // arrays + primitives are leaf updates
      result[path] = value;
    }
  }, {});
};

const getItemsForSave = (items) => {
  return _.chain(items)
    .filter(item => !item._isFirstItem)
    .map(item => {
      const clone = { ...item };
      delete clone._isFirstItem;
      return clone;
    })
    .value();
};

const getItemPositions = (items) => {
  const hasFirstItemLogic = _.some(items, '_isFirstItem')
  if (hasFirstItemLogic) {
    const _items = getItemsForSave(items)
    const updates = _items.reduce((acc, item, index) => {
      acc[item.key] = {
        position: index,
        propSection: item.propSection
      };
      return acc;
    }, {});
    return updates
  } else {
    const updates = items.reduce((acc, item, index) => {
      acc[item.key] = {
        position: index,
      };
      return acc;
    }, {});
    return updates
  }

}

const updateViewItem = (state, viewItemKey, viewItem) => {
  const nextState = _.cloneDeep(state)
  _.set(
    nextState,
    ['apsViewItems', viewItemKey],
    viewItem
  )
  const { _diffs, diffCount } = getDiffs(nextState)
  return { ...nextState, _diffs, diffCount }
}

const updateViewItemsInGlobal = (state, items, positionsOnly) => {
  const nextState = _.cloneDeep(state);
  const { allGroups } = nextState
  const lastGroup = allGroups?.[_.size(allGroups) - 1]
  const { key: lastGroupKey } = lastGroup ?? {}
  const _keyPath = state.keyPath.replace('views', 'viewItems')
  const _cp = removeFromStart(_keyPath, 1)
  if (positionsOnly) {
    const updates = getItemPositions(items)
    _.forEach(updates, (update, updateKey) => {
      const path = `${_cp}.${updateKey}`;
      const existing = _.get(nextState.apsViewItems, path, {});
      _.set(nextState.apsViewItems, path, { ...existing, ...update });
    });
  } else {
    _.forEach(items, (item, itemKey) => {
      const path = `${_cp}.${itemKey}`;
      const existing = _.get(nextState.apsViewItems, path, {});
      _.set(nextState.apsViewItems, path, { ...existing, ...item });
    });
  }
  const { _diffs, diffCount } = getDiffs(nextState)

  console.groupEnd()
  return { ...nextState, _diffs, diffCount }
}

const updateViewItemsInViews = (state, items, positionsOnly) => {
  const nextState = _.cloneDeep(state);
  const _cp = `${state.pageView}.${state.keyPath}`
  if (positionsOnly) {
    const updates = getItemPositions(items)
    _.forEach(updates, (update, updateKey) => {
      const path = `${_cp}.${updateKey}`;
      const existing = _.get(nextState.apsViews, path, {});
      _.set(nextState.apsViews, path, { ...existing, ...update });
    });
  } else {
    _.forEach(items, (item, itemKey) => {
      const path = `${_cp}.${itemKey}`;
      const existing = _.get(nextState.apsViews, path, {});
      _.set(nextState.apsViews, path, { ...existing, ...item });
    });
  }
  const { _diffs, diffCount } = getDiffs(nextState)
  return { ...nextState, _diffs, diffCount }
}

const updatePropItem = (state, propItemKey, propItem) => {
  const nextState = _.cloneDeep(state)
  // _.set(
  //   nextState,
  //   ['apsViews', viewItemKey],
  //   viewItem
  // )
  const { _diffs, diffCount } = getDiffs(nextState)
  return { ...nextState, _diffs, diffCount }
}

const getDiffs = (state) => {
  const diffs_g = getDiff(state?.apsGlobal, state?.baseline.aps_global)
  const diffs_vi = getDiff(state?.apsViewItems, state?.baseline.aps_viewItems)
  const diffs_v = getDiff(state?.apsViews, state?.baseline.aps_views)
  const update_global = { ...diffToFirestoreUpdate(diffs_g) }
  const update_viewItems = { ...diffToFirestoreUpdate(diffs_vi) }
  const update_views = { ...diffToFirestoreUpdate(diffs_v) }

  const sections = [
    { key: 'global', stateKey: 'apsGlobal', baselineKey: 'aps_global' },
    { key: 'viewItems', stateKey: 'apsViewItems', baselineKey: 'aps_viewItems' },
    { key: 'views', stateKey: 'apsViews', baselineKey: 'aps_views' },
  ];

  const _diffs = { dataToUpdate: {}, data: {} };

  sections.forEach(({ key, stateKey, baselineKey }) => {
    const diffs = getDiff(state?.[stateKey], state?.baseline?.[baselineKey]);
    const update = diffToFirestoreUpdate(diffs);

    if (!_.isEmpty(update)) {
      _diffs.dataToUpdate[key] = update;
      _diffs.data[key] = diffs;
    }
  });

  return { _diffs, diffCount: _.size(update_global) + _.size(update_viewItems) + _.size(update_views) }
}

const removeFromStart = (str, count) =>
  str
    ? str.split('.').slice(count).join('.')
    : ''

const removeFromEnd = (str, count) =>
  str
    ? str.split('.').slice(0, -count || undefined).join('.')
    : ''